import { jsx as _jsx } from "react/jsx-runtime";
import SegmentedAntd from 'antd/lib/segmented';
import styled, { css } from 'styled-components';
/**
 * 分段选择器，又叫胶囊选择，适用于选项不多且固定的筛选功能
 *
 * @param {SegmentedProps} param0 - 参数对象
 * @returns 分段选择器
 */
export const Segmented = ({ options, value, onChange, disabled, className, inverse, bold, itemXPadding, }) => {
    return (_jsx(StyledSegmented, { options: options, value: value, onChange: val => onChange(val), disabled: disabled, className: className, "$inverse": inverse, "$bold": bold, "$itemXPadding": itemXPadding !== null && itemXPadding !== void 0 ? itemXPadding : 12, 
        // 这里传两处 undefined 是因为 antd typing 没有兼容 react 17 => https://github.com/ant-design/ant-design/issues/39251
        onResize: undefined, onResizeCapture: undefined }, void 0));
};
const StyledSegmented = styled(SegmentedAntd) `
  &&& {
    background-color: ${({ theme }) => theme.background._4};
    &:hover {
      background-color: ${({ theme }) => theme.background._5};
    }

    .ant-segmented-item {
      color: ${({ theme }) => theme.text._2};

      &-label {
        padding: 0 ${({ $itemXPadding }) => $itemXPadding}px;
      }

      &-selected {
        color: ${({ theme }) => theme.brand.text0};
        font-weight: bold;
      }

      &-disabled {
        color: ${({ theme }) => theme.text._4};
      }
    }

    // 反色模式
    ${({ $inverse: inverse, theme }) => !!inverse &&
    css `
        background-color: ${theme.background._0};

        &:hover {
          background-color: ${theme.background._1};
        }

        .ant-segmented-item {
          &-selected {
            box-shadow: none;
            background-color: transparent;
          }
        }

        // 隐藏胶囊
        .ant-segmented-thumb {
          opacity: 0;
        }

        // 动画速度，因为不显示胶囊的移动所以设置小一些，设置为 0 会导致组件失效
        .ant-segmented-thumb-motion {
          transition: all 20ms;
        }
      `}

    // 字体加粗
    ${({ $bold }) => !!$bold &&
    css `
        font-weight: bold;
      `}
  }
`;
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoiU2VnbWVudGVkLmpzIiwic291cmNlUm9vdCI6IiIsInNvdXJjZXMiOlsiLi4vLi4vLi4vc3JjL1NlbGVjdC9TZWdtZW50ZWQudHN4Il0sIm5hbWVzIjpbXSwibWFwcGluZ3MiOiI7QUFBQSxPQUFPLGFBQWlDLE1BQU0sb0JBQW9CLENBQUE7QUFDbEUsT0FBTyxNQUFNLEVBQUUsRUFBRSxHQUFHLEVBQUUsTUFBTSxtQkFBbUIsQ0FBQTtBQW9DL0M7Ozs7O0dBS0c7QUFDSCxNQUFNLENBQUMsTUFBTSxTQUFTLEdBQUcsQ0FBb0MsRUFDM0QsT0FBTyxFQUNQLEtBQUssRUFDTCxRQUFRLEVBQ1IsUUFBUSxFQUNSLFNBQVMsRUFDVCxPQUFPLEVBQ1AsSUFBSSxFQUNKLFlBQVksR0FDTSxFQUFFLEVBQUU7SUFDdEIsT0FBTyxDQUNMLEtBQUMsZUFBZSxJQUNkLE9BQU8sRUFBRSxPQUFPLEVBQ2hCLEtBQUssRUFBRSxLQUFLLEVBQ1osUUFBUSxFQUFFLEdBQUcsQ0FBQyxFQUFFLENBQUMsUUFBUSxDQUFDLEdBQVEsQ0FBQyxFQUNuQyxRQUFRLEVBQUUsUUFBUSxFQUNsQixTQUFTLEVBQUUsU0FBUyxjQUNWLE9BQU8sV0FDVixJQUFJLG1CQUNJLFlBQVksYUFBWixZQUFZLGNBQVosWUFBWSxHQUFJLEVBQUU7UUFDakMseUdBQXlHO1FBQ3pHLFFBQVEsRUFBRSxTQUFTLEVBQ25CLGVBQWUsRUFBRSxTQUFTLFdBQzFCLENBQ0gsQ0FBQTtBQUNILENBQUMsQ0FBQTtBQUVELE1BQU0sZUFBZSxHQUFHLE1BQU0sQ0FBQyxhQUFhLENBQUMsQ0FJM0M7O3dCQUVzQixDQUFDLEVBQUUsS0FBSyxFQUFFLEVBQUUsRUFBRSxDQUFDLEtBQUssQ0FBQyxVQUFVLENBQUMsRUFBRTs7MEJBRWhDLENBQUMsRUFBRSxLQUFLLEVBQUUsRUFBRSxFQUFFLENBQUMsS0FBSyxDQUFDLFVBQVUsQ0FBQyxFQUFFOzs7O2VBSTdDLENBQUMsRUFBRSxLQUFLLEVBQUUsRUFBRSxFQUFFLENBQUMsS0FBSyxDQUFDLElBQUksQ0FBQyxFQUFFOzs7cUJBR3RCLENBQUMsRUFBRSxhQUFhLEVBQUUsRUFBRSxFQUFFLENBQUMsYUFBYTs7OztpQkFJeEMsQ0FBQyxFQUFFLEtBQUssRUFBRSxFQUFFLEVBQUUsQ0FBQyxLQUFLLENBQUMsS0FBSyxDQUFDLEtBQUs7Ozs7O2lCQUtoQyxDQUFDLEVBQUUsS0FBSyxFQUFFLEVBQUUsRUFBRSxDQUFDLEtBQUssQ0FBQyxJQUFJLENBQUMsRUFBRTs7Ozs7TUFLdkMsQ0FBQyxFQUFFLFFBQVEsRUFBRSxPQUFPLEVBQUUsS0FBSyxFQUFFLEVBQUUsRUFBRSxDQUNqQyxDQUFDLENBQUMsT0FBTztJQUNULEdBQUcsQ0FBQTs0QkFDbUIsS0FBSyxDQUFDLFVBQVUsQ0FBQyxFQUFFOzs7OEJBR2pCLEtBQUssQ0FBQyxVQUFVLENBQUMsRUFBRTs7Ozs7Ozs7Ozs7Ozs7Ozs7OztPQW1CMUM7OztNQUdELENBQUMsRUFBRSxLQUFLLEVBQUUsRUFBRSxFQUFFLENBQ2QsQ0FBQyxDQUFDLEtBQUs7SUFDUCxHQUFHLENBQUE7O09BRUY7O0NBRU4sQ0FBQSJ9